import { BaseApiService } from '@doccareplus/api-client';

export interface ClinicAccessResponse {
  activeRoleId: string;
  activeRoleName: string;
  workspaceProfile: import('@doccareplus/kernel/domain').WorkspaceProfile;
  defaultRoute: string;
  permissions: string[];
  enabledFeatures: string[];
  subscriptionStatus: string;
  canWrite: boolean;
  trialEndsAt: string | null;
  graceEndsAt: string | null;
  planName?: string | null;
  currency?: string | null;
  finalPrice?: number | null;
  clinicTimeZone: string;
  clinicDate: string;
}

/** The clinic's own current subscription — plan, status, and commercial terms (see FE-3). */
export interface SubscriptionResponse {
  id: string;
  clinicId: string;
  planId: string;
  planName: string;
  status: string;
  trialEndsAt?: string | null;
  currentPeriodStart?: string | null;
  currentPeriodEnd?: string | null;
  billingInterval?: string | null;
  currency?: string | null;
  listPrice?: number | null;
  finalPrice?: number | null;
  discountPercentage?: number | null;
  discountAmount?: number | null;
  discountCyclesRemaining?: number;
}

/** One SaaS billing history entry for the clinic's own subscription (see BP-2). */
export interface ClinicBillingRecord {
  id: string;
  listPrice: number;
  discountAmount: number;
  amount: number;
  currency: string;
  description: string;
  referenceNumber?: string | null;
  status: string;
  issuedAt: string;
  periodStart?: string | null;
  periodEnd?: string | null;
  dueAt?: string | null;
  paidAt?: string | null;
}

class ClinicAccessApi extends BaseApiService {
  constructor() {
    super('/clinic');
  }

  getAccess(): Promise<ClinicAccessResponse> {
    return this.get<ClinicAccessResponse>('/access');
  }

  getSubscription(): Promise<SubscriptionResponse> {
    return this.get<SubscriptionResponse>('/subscription');
  }

  getBillingHistory(): Promise<ClinicBillingRecord[]> {
    return this.get<ClinicBillingRecord[]>('/subscription/billing-history');
  }
}

export const clinicAccessApi = new ClinicAccessApi();
